import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M10.25 7.129V8h-6A2.247 2.247 0 0 0 2 10.25V20h-.75a.75.75 0 0 0 0 1.5h19.5a.75.75 0 0 0 0-1.5H20v-9.75A2.247 2.247 0 0 0 17.75 8h-6v-.872a2.37 2.37 0 0 0 1.616-2.243c0-.402-.16-.969-.409-1.559C12.46 2.152 11.634.848 11.634.848a.75.75 0 0 0-1.266 0S9.54 2.152 9.042 3.326c-.248.59-.408 1.157-.408 1.559 0 1.043.678 1.93 1.616 2.244M18.5 15.9l-3.754-2.51a.75.75 0 0 0-.898.049l-1.764 1.474a2.25 2.25 0 0 1-2.886 0l-1.746-1.46a.75.75 0 0 0-.91-.04L3.5 15.535V20h15zm0-1.804V10.25a.75.75 0 0 0-.75-.75H4.25a.75.75 0 0 0-.75.75v3.457l2.185-1.524a2.25 2.25 0 0 1 2.73.12l1.745 1.46a.75.75 0 0 0 .962 0l1.764-1.474a2.25 2.25 0 0 1 2.693-.144zM11 2.737c.123.227.251.473.37.722.255.53.496 1.068.496 1.426a.866.866 0 0 1-1.732 0c0-.358.241-.897.495-1.426.12-.25.248-.495.371-.722",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }